// extracted by mini-css-extract-plugin
export var errorIcon = "_j4-1";
export var nameLogo = "_j4-0";